import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';
import useSpecial from "./WebView/utils/useSpecial";
import { buildProductPayload } from "./WebView/utils/ProductForm";

function FullImage({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);

  const [imgurl, setImgurl] = useState("");

  const [image, setImage] = useState("");

  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
        setImage(e.target.files[0]);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted")
        setValue("image", "")
      }
    } else {
      if (flag === "edit") {
        setImgurl(editdata.img_urls);
        setPreview(prev => ({ ...prev, img_urls: editdata.img_urls }));
      } else {
        setProgress(0);
        setImgurl("");
        setPreview(prev => ({ ...prev, img_urls: "" }));
      }
    }
  };



  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const formData = new FormData();
  formData.append("files", image);
  formData.append("from", 'full_image');
  const imageUrl = async () => {
    try {
      let url = await api({
        url: `/upload/image`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        setImgurl(url.data.data);
        setPreview({ img_urls: url.data.data, sub_type: "full_image" });
      } else {
        setProgress(0);
        setValue("image", null);
        if (flag === "edit") setImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
    const { SpecialForm, schema } = useSpecial({ 
      control, 
      register, 
      editdata: editdata || null,
      setValue,
      errors 
    });
  useEffect(() => {
    if (image) {
      imageUrl();
    }
  }, [image]);

  let watchcentercheck = watch("centercheck");
  let watchsubscription = watch("subscription")
  if (flag === "edit") {
    watchcentercheck = watch(
      "centercheck",
      editdata.center === 1 ? true : false
    );
  }
  if (flag === "edit") {
    watchsubscription = watch(
      "subscription",
      editdata.click_url === '12' ? true : false
    );
  }
  let watchlongimageCheck = watch("longimageCheck");
  if (flag === "edit") {
    watchlongimageCheck = watch(
      "longimageCheck",
      editdata?.video_controls?.long_image === 1 ? true : false
    );
  }
  let watchcheck = watch("btnclick");
  if (flag === "edit")
    watchcheck = watch(
      "btnclick",
      editdata.button_enabled === 1 ? true : false
    );

  useEffect(() => {
    if (watchcheck !== false) {
      setPreview(prev => ({ ...prev, button_enabled: watchcheck, position: "Bottom" }));
    } else {
      setPreview(prev => ({ ...prev, button_enabled: false, position: "" }));
    }
  }, [watchcheck]);

  // let watchposition = watch("position", "Bottom");
  // useEffect(() => {

  //   if (watchposition !== "Top") {
  //     setPreview({ ...preview, position: watchposition });
  //   } else {
  //     setPreview({ ...preview, position: "Top" });
  //   }
  // }, [watchposition]);

  let watchbtntext = watch("btntext");
  useEffect(() => {

    if (watchbtntext !== "") {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: "", btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    }
  }, [watchbtntext]);

  let watchbtnurl = watch("btnurl", false);
  useEffect(() => {

    if (watchbtnurl !== "") {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: '', button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr}));
    }
  }, [watchbtnurl]);

  let watchbuttonLang = watch("buttonLang", false);
  useEffect(() => {

    if (watchbuttonLang !== "") {
      setPreview(prev => ({ ...prev, button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: '', btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    }
  }, [watchbuttonLang]);

  let watchbtntextclr = watch("btntextclr")
  useEffect(() => {

    if (watchbtntextclr !== "") {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr }));
    } else {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: '', btn_text_bgclr: watchbtntextbgclr}));
    }
  }, [watchbtntextclr]);

  let watchbtntextbgclr = watch("btntextbgclr")
  useEffect(() => {

    if (watchbtntextbgclr !== "") {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: watchbtntextbgclr}));
    } else {
      setPreview(prev => ({ ...prev,button_enabled : watchcheck,button_link: watchbtnurl, button_text: watchbtntext, btn_text_lang: watchbuttonLang, btn_text_clr: watchbtntextclr, btn_text_bgclr: '' }));
    }
  }, [watchbtntextbgclr]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview(prev => ({
        ...prev,
        sub_type: editdata.sub_type,
        img_urls: editdata.img_urls,
        // position: editdata.position === 0 ? "Top" : "Bottom",
        button_enabled: editdata.button_enabled,
        button_text: editdata.button_text,
        button_link: editdata.button_link,
        btn_text_lang: editdata.btn_text_lang,
        btn_text_clr:editdata.btn_text_clr,
        btn_text_bgclr:editdata.btn_text_bgclr
      }));
    }
    setPreview(prev => ({ ...prev, sub_type: "full_image" }));
  }, [company]);



  const onSubmit = async (data) => {
    console.log("data", data);
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        img_url: imgurl,
        clickurl:watchsubscription === true ? '12' : data.clickurl,
        center: data.centercheck,
        long_image: data.longimageCheck,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        btnclick: watchcheck,
        btntext: data.btntext,
        btnurl: data.btnurl,
        // position: data.position,
        btn_text_lang: parseInt(data.buttonLang),
        btn_text_clr:data.btntextclr,
        btn_text_bgclr:data.btntextbgclr,
        schema,
        special:data.special,
        ...buildProductPayload(data),
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/image/fullimage`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_type: editdata.creative_type,
        creative_name: creative_name,
        creative_id: editdata.creative_id,
        sub_type: editdata.sub_type,
        clickurl: watchsubscription === true ? '12' : data.clickurl,
        center: data.centercheck,
        long_image: data.longimageCheck,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
         schema,
        special:data.special,
        ...buildProductPayload(data),
      };
      image !== "" ? (obj.img_url = imgurl) : (obj.img_url = editdata.img_urls);
      watchcheck === true ? (obj.btnclick = true) : (obj.btnclick = false);
      watchcheck === true ? (obj.btntext = data.btntext) : (obj.btntext = "");
      watchcheck === true ? (obj.btnurl = data.btnurl) : (obj.btnurl = "");
      watchcheck === true ? (obj.btn_text_clr = data.btntextclr) : (obj.btn_text_clr = "");
      watchcheck === true ? (obj.btn_text_bgclr = data.btntextbgclr) : (obj.btn_text_bgclr = "");
      // watchcheck === true
      //   ? (obj.position = data.position)
      //   : (obj.position = "Top");
      watchcheck === true
        ? (obj.btn_text_lang = parseInt(watchbuttonLang))
        : (obj.btn_text_lang = null);
      try {
        let res = await api({
          url: `/creatives/image/editimage`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);

        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  console.log(errors)

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
              <div className="mb-3">
                <label className="form-label">Image</label><br />
                <span>(Image height should be greater than width )</span>
                <input
                  className="form-control mb-2"
                  type="file"
                  id="formFile"
                  name="files"
                  {...register("image", {
                    required: flag === "edit" ? false : true,
                    onChange: (e) => imageChange(e),
                  })}
                />
                {errors.image && (
                  <p className="text-red-600">Image is mandatory</p>
                )}
                {
                  progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : imgurl !== "" ? (
                    <span>{`${imgurl}`}</span>
                  ) : (
                    flag === "edit" && <span>{`${editdata.img_urls}`}</span>
                  )}
              </div>

              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Click URL / Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url !== '12' ? editdata.click_url : ''}
                    disabled={watchsubscription}
                    name="clickurl"
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                       /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchsubscription}
                  {...register("subscription", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Subscription
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchcentercheck}
                  {...register("centercheck", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Center
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchlongimageCheck}
                  {...register("longimageCheck", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Long Image
                </label>
              </div>
              <section>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchcheck}
                  {...register("btnclick", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Enable Button Click
                </label>
              </div>
              {watchcheck && (
                <div className="row mb-6">
                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_text}
                      {...register("btntext", { required: watchcheck })}
                    />
                    {errors.btntext && (
                      <p className="text-red-600">Button Text is mandatory</p>
                    )}
                  </div>
                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text color
                    </label>
                    <input
                      type="color"
                      defaultValue={editdata.btn_text_clr}
                      {...register("btntextclr", { required: watchcheck })}
                    />
                    {errors.btn_text_clr && (
                      <p className="text-red-600">Button Text color is mandatory</p>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Text background color
                    </label>
                    <input
                      type="color"
                      defaultValue={flag === "edit" ? editdata.btn_text_bgclr : "#ffffff"}
                      {...register("btntextbgclr", { required: watchcheck })}
                    />
                    {errors.btn_text_clr && (
                      <p className="text-red-600">Button Text background color  is mandatory</p>
                    )}
                  </div>

                  <div className="col">
                    <label htmlFor="" className="form-label">
                      Button Link
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata.button_link}
                      {...register("btnurl", {
                        required: watchcheck,
                        pattern: {
                          value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.btnurl?.type === "pattern" && (
                      <p className="text-red-600">{errors.btnurl.message}</p>
                    )}
                    {errors.btnurl
                      ? errors.btnurl?.type !== "pattern" && (
                          <p className="text-red-600">
                            {"Button URL Mandatory"}
                          </p>
                        )
                      : null}
                  </div>
                  <div className="col">
                    <label className="form-label">Position</label>
                    <select
                      className="form-select"
                      type="text"
                      // defaultValue={
                      //   flag === "edit"
                      //     ? editdata.position === 0
                      //       ? "Top"
                      //       : "Bottom"
                      //     : "Top"
                      // }
                      disabled
                      defaultValue={"Bottom"}
                      {...register("position", { required: false })}
                    >
                      <option defaultValue="Top">Top</option>
                      <option value="Bottom">Bottom</option>
                    </select>
                  </div>
                  <div className="col">
                    <label className="form-label">Button Lang</label>
                    <select
                      className="form-select"
                      type="text"
                      defaultValue={
                        flag === "edit"
                          ? editdata.btn_text_lang !== null
                            ? `${editdata.btn_text_lang}`
                            : "1"
                          : "1"
                      }
                      {...register("buttonLang", { required: true })}

                    >
                      <option value="1">Telugu</option>
                      <option value="7">Bengali</option>
                      <option value="3">Hindi</option>
                      <option value="6">Marathi</option>
                      <option value="2">Tamil</option>
                      <option value="4">Kannada</option>
                      <option value="5">Malayalam</option>
                      <option value="8">Gujarathi</option>
                      <option value="10">Oria</option>
                      <option value="11">English</option>
                      <option value="13">Telugu-English</option>
                    </select>
                  </div>

                </div>
              )}
            </section>
             {SpecialForm()}
              <div className="my-3 text-end">
                <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default FullImage;
